import BaseEnumType from "../../common/base-enum-type";

const DriveEndType = Object.freeze({
    Turnover: new BaseEnumType("Turnover", "Turnover"),
    TurnoverOnDefenseForTouchdown: new BaseEnumType(
        "TurnoverOnDefenseForTouchdown",
        "Turnover On Defense For Touchdown"
    ),
    Punt: new BaseEnumType("Punt", "Punt"),
    Touchdown: new BaseEnumType("Touchdown", "Touchdown"),
    TurnoverOnDowns: new BaseEnumType("TurnoverOnDowns", "Turnover On Downs"),
    Halftime: new BaseEnumType("Halftime", "Halftime"),
    EndOfGame: new BaseEnumType("EndOfGame", "End Of Game"),
    Unknown: new BaseEnumType("Unknown", "Unknown (Not ended or manual)"),
    Safety: new BaseEnumType("Safety", "Safety"),
    FieldGoal: new BaseEnumType("FieldGoal", "Field Goal"),
    Rouge: new BaseEnumType("Rouge", "Rouge"),
    Deuce: new BaseEnumType("Deuce", "Deuce"),
    DropKickFieldGoal: new BaseEnumType(
        "DropKickFieldGoal",
        "Drop Kick Field Goal"
    )
});

/**
 * Drive end types where the rules create a new drive before the kickoff,
 * so an active drive during kickoff is expected and should not be finalized.
 */
export const KICKOFF_DRIVE_END_TYPES = Object.freeze([
    DriveEndType.Safety.code,
    DriveEndType.FieldGoal.code,
    DriveEndType.DropKickFieldGoal.code
]);

export default DriveEndType;
